import {
  Activity,
  Bell,
  CircleCheck,
  Clock,
  Compass,
  FilePen,
  FileText,
  FlaskConical,
  LayoutGrid,
  Link2,
  Rocket,
  Scale,
  Target,
  Workflow,
  createLucideIcon,
} from "lucide-react";

const Horse = createLucideIcon("Horse", [
  ["path", { d: "M22 6v3.5l-1.5.5l-1.54-2.46c-.13-.21-.46-.12-.46.13v3.58c0 .98-.39 1.86-1 2.53V21H15v-6h-.25c-.21 0-.42-.03-.62-.06l-4.44-.74l-1.12 2.01l.96 4.79H7l-1-4.75c-.03-.3 0-.6.16-.86l1.02-1.81a3.27 3.27 0 0 1-1.68-2.77c-.04.15-.06.37-.03.69c.03.44.14 1.09.07 1.81c-.04.72-.37 1.46-.79 1.95c-.43.49-.9.83-1.4 1.09l-.7-.7c.19-.47.38-.89.42-1.28c.06-.37-.01-.67-.12-.94l-.53-1.13c-.21-.51-.47-1.25-.42-2.12c.03-.85.5-1.96 1.39-2.57c.9-.61 1.87-.69 2.66-.53c.5.1 1.01.34 1.45.68c.37-.17.8-.26 1.25-.26h5.75V7c0-2.21 1.79-4 4-4H22l-.89 1.34c.54.36.89.97.89 1.66", fill: "currentColor", stroke: "none", key: "mdi-horse" }],
]);

const ICON_BY_BASE_NAME = {
  "jantro-integral-test-suite": FlaskConical,
  "jantro-launch-dashboard": Rocket,
  "jantro-recon-test-bed": Scale,
  "jantro-ready-to-go": CircleCheck,
  "jantro-notification-dashboard": Bell,
  "jantro-event-dashboard": Activity,
  "jantro-integrations-ops": Workflow,
  "jantro-client-contracts": FilePen,
  "time-stream-display": Clock,
  "jantro-workflow-hub": Workflow,
  "jantro-007": Target,
  "jantro-eval-harness": Horse,
  "jantro-conversation-compass": Compass,
  "jantro-document-review": FileText,
  "jantro-utm-admin": Link2,
};

export function getAppIcon(baseName) {
  return ICON_BY_BASE_NAME[baseName] || LayoutGrid;
}
